import { Auth } from 'aws-amplify';

export default async (oldPassword, newPassword) => {
  try {
    const user = await Auth.currentAuthenticatedUser();
    return Auth.changePassword(user, oldPassword, newPassword);
  } catch (error) {
    console.error('Unable to change password: ', error); // eslint-disable-line no-console
    throw error;
  }
};
